import { StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    buttonLeft: {
        width: widthPercentageToDP(25),
    },
});

export default styles;
